import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';

const StyledScrollableCell = styled(Flexer.Parent).attrs(() => ({
  alignItems: 'stretch',
}))`
  overflow: hidden;
  overflow-x: auto;
`;

export default StyledScrollableCell;
